export const ROUTES = {
  NEW_QUESTIONS: '/new-questions',
  QUESTIONS: '/questions',
  COURSES: '/courses',
  QR: '/qr',
} as const;
